import { createRegisterableComponent } from '@news-mono/web-common'
import { Pagination, PaginationProps } from './Pagination'
import React from 'react'

type PaginationRegistrationProps = Omit<
    PaginationProps,
    'dataDefinition' | 'data' | 'services'
>

export const PaginationRegistration = createRegisterableComponent(
    'pagination',
    ({ contextId }: PaginationRegistrationProps, services) => (
        <Pagination contextId={contextId} services={services} />
    ),
)
